import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BrakesFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12.72 20.74C10.22 20.74 7.94 19.68 6.34 17.98L5.36 18.94C3.5 17.08 2.44 14.6 2.44 11.96C2.44 9.32 3.5 6.84 5.36 4.98L6.34 5.94C7.94 4.24 10.22 3.18 12.72 3.18C17.54 3.18 21.54 7.16 21.54 11.96C21.54 16.76 17.54 20.74 12.72 20.74ZM7.24 16.88L8.8 15.42C7.74 14.28 7.24 13.22 7.24 11.96C7.24 10.7 7.74 9.64 8.8 8.5L7.24 7.04C5.82 8.46 5.08 10.14 5.08 11.96C5.08 13.78 5.82 15.46 7.24 16.88ZM12.72 14.6C14.14 14.6 15.36 13.38 15.36 11.96C15.36 10.54 14.14 9.32 12.72 9.32C11.3 9.32 10.08 10.54 10.08 11.96C10.08 13.38 11.3 14.6 12.72 14.6Z" />
    </SvgIcon>
  );
});
